
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NativeBridge } from '@portal/react-native-api';

type Link = {
	linkUrl: string;
	linkText: string;
}[];

@Component
export default class KontaktPage extends Vue {
	private factory = new NativeBridge();
	private api = this.factory.getNativeApi();

	links: Link = [
		{
			linkUrl: 'https://www.seeligerbank.de/',
			linkText: 'Bankhaus C. L. Seeliger'
		},
		{
			linkUrl: 'http://www.martinbank.de/',
			linkText: 'Bankhaus Gebr. Martin AG'
		},
		{
			linkUrl: 'http://www.hafnerbank.de/',
			linkText: 'Bankhaus Hafner'
		},
		{
			linkUrl: 'http://www.bankhaus-faisst.de/',
			linkText: 'Bankhaus J. Faisst OHG'
		},
		{
			linkUrl: 'http://www.sperrer.de/',
			linkText: 'Bankhaus Ludwig Sperrer KG'
		},
		{
			linkUrl: 'https://www.flessabank.de/',
			linkText: 'Bankhaus Max Flessa KG'
		},
		{
			linkUrl: 'http://www.bankhaus-mayer.de/',
			linkText: 'Bankhaus Mayer'
		},
		{
			linkUrl: 'https://www.neelmeyer.de/home/',
			linkText: 'Bankhaus Neelmeyer'
		},
		{
			linkUrl: 'http://www.bbbank.de/',
			linkText: 'BBBank eG'
		},
		{
			linkUrl: 'https://www.degussa-bank.de/',
			linkText: 'Degussa Bank AG'
		},
		{
			linkUrl: 'https://www.donner-reuschel.de/',
			linkText: 'Donner & Reuschel AG'
		},
		{
			linkUrl: 'https://www.gabler-saliter-bank.de/',
			linkText: 'Gabler-Saliter Bankgeschäft AG'
		},
		{
			linkUrl: 'https://www.merkur-bank.de/',
			linkText: 'MERKUR PRIVATBANK'
		},
		{
			linkUrl: 'http://www.national-bank.de/',
			linkText: 'NATIONAL-BANK AG'
		},
		{
			linkUrl: 'https://www.olb.de/',
			linkText: 'Oldenburgische Landesbank AG'
		},
		{
			linkUrl: 'https://www.pax-bank.de/homepage.html/',
			linkText: 'PAX-Bank eG'
		},
		{
			linkUrl: 'https://www.santander.de/privatkunden/',
			linkText: 'Santander Consumer Bank AG'
		},
		{
			linkUrl: 'https://www.sparda-a.de/impressum/',
			linkText: 'Sparda-Bank Augsburg e.G.'
		},
		{
			linkUrl: 'https://www.sparda-bw.de/impressum/',
			linkText: 'Sparda-Bank BaWü eG'
		},
		{
			linkUrl: 'https://www.sparda-b.de/kontakt-zur-bank.php/',
			linkText: 'Sparda-Bank Berlin eG'
		},
		{
			linkUrl: 'https://www.sparda-bank-hamburg.de/impressum/',
			linkText: 'Sparda-Bank Hamburg eG'
		},
		{
			linkUrl: 'https://www.sparda-h.de/service/rechtliche-hinweise/impressum.html',
			linkText: 'Sparda-Bank Hannover eG'
		},
		{
			linkUrl: 'https://www.sparda-hessen.de/impressum/',
			linkText: 'Sparda-Bank Hessen eG'
		},
		{
			linkUrl: 'https://www.sparda-m.de/impressum/',
			linkText: 'Sparda-Bank München eG'
		},
		{
			linkUrl: 'https://www.sparda-n.de/impressum/',
			linkText: 'Sparda-Bank Nürnberg eG'
		},
		{
			linkUrl: 'https://www.sparda-ostbayern.de/impressum/',
			linkText: 'Sparda-Bank Ostbayern eG'
		},
		{
			linkUrl: 'https://www.sparda-sw.de/impressum/',
			linkText: 'Sparda-Bank Südwest eG'
		},
		{
			linkUrl: 'https://www.sparda-west.de/impressum/',
			linkText: 'Sparda-Bank West eG'
		},
		{
			linkUrl: 'https://www.steyler-bank.de/',
			linkText: 'Steyler Bank'
		},
		{
			linkUrl: 'https://www.suedwestbank.de/',
			linkText: 'SÜDWESTBANK - BAWAG AG Niederlassung Deutschland'
		},
		{
			linkUrl: 'https://www.targobank.de/',
			linkText: 'TARGOBANK AG'
		}
	];

	navigateTo(url: string): void {
		const { isAppView } = this.$store.state;

		if (isAppView) {
			this.api.openURL(url);
		} else {
			window.open(url, '_blank');
		}
	}
}
